import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e4b4bbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "test-questions" }
const _hoisted_2 = {
  key: 0,
  class: "img"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "img only-audio"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<p class=\"only-audio\" data-v-1e4b4bbe> この<ruby data-v-1e4b4bbe>問題<rt data-v-1e4b4bbe>もんだい</rt></ruby>はリスニング<ruby data-v-1e4b4bbe>音声<rt data-v-1e4b4bbe>おんせい</rt></ruby>のみです。<br data-v-1e4b4bbe> よく<ruby data-v-1e4b4bbe>聞<rt data-v-1e4b4bbe>き</rt></ruby>いて、<ruby data-v-1e4b4bbe>当<rt data-v-1e4b4bbe>あ</rt></ruby>てはまる<ruby data-v-1e4b4bbe>番号<rt data-v-1e4b4bbe>ばんごう</rt></ruby>の○を、<ruby data-v-1e4b4bbe>押<rt data-v-1e4b4bbe>お</rt></ruby>して<ruby data-v-1e4b4bbe>答<rt data-v-1e4b4bbe>こた</rt></ruby>えてください。 </p>", 1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["innerHTML"]

import { ref, inject, toRefs } from "vue"
import { examKey } from "@/main";
import { Page } from "@/store/exam";

interface Props {
  question: Page
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Layout8',
  props: {
    question: null
  },
  setup(__props: any) {

const props = __props as {
  question: Page
};

const exam = inject(examKey);



const { question } = toRefs(props);

const image = ref<string>();

const init = async () => {
  if (!question.value.image) return;
  const questions = await exam?.questions();
  image.value = questions?.images[question.value.image];
}
init();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(question).image)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_unref(question).image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: image.value,
                  alt: ""
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6)),
      (_unref(question).example)
        ? (_openBlock(), _createElementBlock("p", {
            key: 2,
            class: "test-hint",
            innerHTML: _unref(question).questions[0].explanation
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})